import { RequestBuilder } from "../requestBuilder";
import {
  ObtainFocusedContextResponseSchema,
  SwitchFocusInputSchema,
  SwitchFocusResponseSchema,
} from "./userContextClient.types";

// GET /user-context - Obtain the user's current focused context
export const ObtainUserContextRequestConfig = new RequestBuilder({
  path: () => "/user-context",
  responseSchema: ObtainFocusedContextResponseSchema,
});

// POST /user-context - Switch the user's focused context
export const SwitchUserContextRequestConfig = new RequestBuilder({
  path: () => "/user-context",
  responseSchema: SwitchFocusResponseSchema,
  bodySchema: SwitchFocusInputSchema,
}).withMethod("POST");
